import { useBeaker } from '@immutabl3/alchemy';

export default function VisibilityGroup({
  beaker,
  children,
}) {
  return (
    <group visible={ useBeaker(beaker, 'visible') }>
      { children }
    </group>
  );
};